document.addEventListener('Searchanise.Loaded', function() {
  (function($) {
    $(document).on('Searchanise.DataRequestEnd', function (event, type, params, data) {
      if (!data.items || !data.items.length)
        return;

      let itemsLengthBefore = data.items.length;
      data.items = data.items.filter(function (e) {
        if (!e.shopify_variants || !e.shopify_variants.length)
          return true;

        e.shopify_variants = e.shopify_variants.filter(function (v) {
          return v.available === "1";
        });

        return e.shopify_variants.length > 0;
      });

      if (data.items.length !== itemsLengthBefore && itemsLengthBefore == data.totalItems) {
        data.totalItems = data.items.length;
      }
    });
  })(window.Searchanise.$);
});